export default __webpack_public_path__ + "static/media/kuda-popup.2c976fff.jpg";